import { ServiceLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { addressFormatter } from '@dreryk/react-common';
import { Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';

export type ServiceLocationTextProps = {
   readonly serviceLocation: ServiceLocation;
};

export const ServiceLocationText = (props: ServiceLocationTextProps): JSX.Element => {
   return (
      <TextSeparator separator={TextSeparatorType.COMMA_SPACE}>
         <Text testId={'name'}>{props.serviceLocation.name}</Text>
         <Text testId={'address'}>{addressFormatter(props.serviceLocation.address)}</Text>
      </TextSeparator>
   );
};
